"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CAPABILITY_FLAGS = void 0;
exports.isKnownCapabilityFlag = isKnownCapabilityFlag;
exports.capabilityLabel = capabilityLabel;
exports.CAPABILITY_FLAGS = [
    { flag: 'can_play_h264', label_i18n: { fr: 'Décodage H.264/AVC', en: 'H.264/AVC decode' } },
    { flag: 'can_play_h265', label_i18n: { fr: 'Décodage H.265/HEVC', en: 'H.265/HEVC decode' } },
    { flag: 'can_play_vp9', label_i18n: { fr: 'Décodage VP9', en: 'VP9 decode' } },
    { flag: 'can_play_av1', label_i18n: { fr: 'Décodage AV1', en: 'AV1 decode' } },
    { flag: 'can_play_webp', label_i18n: { fr: 'Décodage WebP', en: 'WebP decode' } },
    { flag: 'can_play_gif_animated', label_i18n: { fr: 'GIF animé', en: 'Animated GIF' } },
    { flag: 'has_audio_out', label_i18n: { fr: 'Sortie audio', en: 'Audio output' } },
    { flag: 'has_hdmi_out', label_i18n: { fr: 'Sortie HDMI', en: 'HDMI output' } },
    { flag: 'supports_kiosk_lock', label_i18n: { fr: 'Mode kiosque verrouillé', en: 'Locked kiosk mode' } },
    { flag: 'supports_hw_attestation', label_i18n: { fr: 'Attestation matérielle (TEE)', en: 'HW attestation (TEE)' } },
    { flag: 'supports_service_worker', label_i18n: { fr: 'Service Worker', en: 'Service Worker' } },
    { flag: 'supports_indexeddb_persistent', label_i18n: { fr: 'IndexedDB persistant', en: 'Persistent IndexedDB' } },
    { flag: 'supports_webcrypto_ed25519', label_i18n: { fr: 'WebCrypto Ed25519 natif', en: 'Native WebCrypto Ed25519' } },
];
const BY_FLAG = new Map(exports.CAPABILITY_FLAGS.map((c) => [c.flag, c]));
function isKnownCapabilityFlag(flag) {
    return BY_FLAG.has(flag);
}
function capabilityLabel(flag, locale) {
    return BY_FLAG.get(flag)?.label_i18n[locale] ?? flag;
}
//# sourceMappingURL=capability-flags.js.map